import { Box, Header, Loader, Table } from '@profitowi/component-library';
import { AxiosError } from 'axios';
import { useCallback, useState } from 'react';
import { useQuery } from 'react-query';
import { SortingRule } from 'react-table';

import ErrorMessages from 'components/ErrorMessages/ErrorMessages';
import { SETTLEMENT } from 'constants/queries/settlement';
import { usePagination } from 'hooks/usePagination';
import { getSettlementBonuses } from 'services/settlement';
import { Page } from 'types/request';
import { Bonus } from 'types/settlement';
import { decodeUriSortParams } from 'utils/table';

import useSettlement from '../../../useSettlement';
import { columns } from './columns';

const BonusesStage = () => {
  const { settlementId = NaN } = useSettlement();
  const pagination = usePagination(10);
  const { currentPage, perPage } = pagination;
  const [sortBy, setSortBy] = useState<Array<SortingRule<any>>>([]);
  const handleSortBy = useCallback((sortBy: SortingRule<any>[]) => setSortBy(sortBy), []);

  const { data, error, isError, isLoading, isSuccess, isFetching } = useQuery<
    Page<Bonus>,
    AxiosError
  >(
    [SETTLEMENT.SETTLEMENT_BONUSES, settlementId, currentPage, perPage, sortBy],
    () => getSettlementBonuses(settlementId, currentPage, perPage, decodeUriSortParams(sortBy)),
    { keepPreviousData: true }
  );

  return (
    <Box className="space-y-6">
      <Header as="h4" size="lg" weight="semibold">
        Premie
      </Header>

      {isError && <ErrorMessages error={error} />}
      {isLoading && <Loader className="h-12 w-12" />}
      {isSuccess && data && (
        <Box.FullWidth>
          <Table
            columns={columns}
            data={data.content.length ? data.content : []}
            pagination={pagination}
            totalPages={data.totalPages}
            isLoading={isFetching}
            sortBy={sortBy}
            onSortBy={handleSortBy}
          />
        </Box.FullWidth>
      )}
    </Box>
  );
};

export default BonusesStage;
